// 菜单 侧边栏
export default [
  { path: '/index', title: '首页', icon: 'home' },
  // {
  //   title: '系统管理',
  //   icon: 'folder-o',
  //   children: [
  //     { path: '/system/basicSet', title: '站点设置' },
  //     { path: '/system/baseSet', title: '基本设置' },
  //     { path: '/system/uploadSet', title: '上传设置' },
  //     { path: '/system/seoSet', title: 'SEO设置' },
  //     { path: '/system/moduleSet', title: '模块设置' },
  //   ]
  // },
  // {
  //   title: '订单管理',
  //   icon: 'folder-o',
  //   children: [
  //     { path: '/order/list', title: '订单列表' }
  //   ]
  // },
  // {
  //   title: '商品管理',
  //   icon: 'folder-o',
  //   children: [
  //     { path: '/goods/list', title: '商品列表' },
  //     { path: '/goods/classify', title: '商品分类' },
  //     { path: '/goods/specialArea', title: '专区管理' },
  //     { path: '/goods/serviceItems', title: '服务项' },
  //     { path: '/goods/specification', title: '规格管理' },
  //     { path: '/goods/managementType', title: '类型管理' },
  //     { path: '/goods/specifications', title: '商品规格' },
  //   ]
  // },
  // {
  //   title: '用户管理',
  //   icon: 'folder-o',
  //   children: [
  //     { path: '/user/list', title: '用户列表' }
  //   ]
  // },
  // {
  //   title: '权限管理',
  //   icon: 'folder-o',
  //   children: [
  //     { path: '/authority/account', title: '帐号管理' },
  //     { path: '/authority/role', title: '角色管理' },
  //     { path: '/authority/propertyNode', title: '权限节点管理' }
  //   ]
  // },
  // {
  //   title: '仓库管理',
  //   icon: 'folder-o',
  //   children: [
  //     { path: '/storehouse/purchase', title: '需求单' },
  //     { path: '/storehouse/shared', title: '共享仓管理' },
  //   ]
  // },
  // { title: '商户管理',
  //   icon: 'folder-o',
  //   children: [
  //     { path: '/factory/list', title: '商户列表' },
  //   ]
  // }
]
